import { Stack } from '@mui/material'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
interface IExpiredLicense {
	mt?: string
}
export const ExpiredLicense = (props: IExpiredLicense) => {
	const { mt = '' } = props
	return (
		<Stack
			direction={'column'}
			justifyContent={'center'}
			alignItems={'center'}
			gap={'12px'}
			mt={mt}
		>
			<TypographySecondary14>Нет данных</TypographySecondary14>
			<TypographySecondary14>
				Истек срок лицензионного соглашения.
				<br />
				Данные за прошлые периоды внутри группы.
			</TypographySecondary14>
		</Stack>
	)
}
